//
// # Schematic Rules Validation (SRV) — core types
//

import { Point } from "../core";

// A read-only description of a rule, shown in the panel's "Rules that will run"
// reference list. Every rule reports errors, so there is no severity field.
export interface SrvRuleDescriptor {
  id: string; // stable id, e.g. "unconnected-pins"
  label: string; // display name in the panel
  description: string; // tooltip / detail copy
}

// A single rule violation. Every violation is an error.
//
// `points` carries the world-space anchor locations where the canvas overlay
// draws its arrows; it is always populated (so the renderer never has to
// resolve entity ids back to coordinates). The id arrays reference the
// offending entities for the Results list and selection, and only include ids
// that are actually present on the entities (schema ids are optional).
export interface SrvViolation {
  ruleId: string;
  message: string;
  points: Array<Point>;
  wireSegmentIds: Array<number>;
  schPinIds: Array<number>;
  instanceIds: Array<number>;
  // The same findings without relying on schema ids: indices into the
  // schematic's wireSegments / pins / instances, the names involved
  // (`instancePins` as "inst.pin"), and how to fix the violation.
  hint?: string;
  wireIndices?: Array<number>;
  portIndices?: Array<number>;
  instanceIndices?: Array<number>;
  instances?: Array<string>;
  instancePins?: Array<string>;
  ports?: Array<string>;
  nets?: Array<string>;
}

export interface SrvRuleStats {
  ruleId: string;
  violationCount: number;
  elapsedMs: number;
}

export interface SrvRunResult {
  ranRuleIds: Array<string>; // always the full rule set — every rule always runs
  violations: Array<SrvViolation>; // consolidated, in rule order
  stats: Array<SrvRuleStats>;
}
